import { combineReducers } from 'redux'
import { reducers } from '@adc/ui-morpheus'
import { EVENT_CHANGES } from '../../constants/tableTypes'
import tableReducer from './columnDefinitions'

const eventHistoryReducer = (state, action) => {
  switch (action.type) {
    case `REPLACE_TABLE_USER_INFO_${EVENT_CHANGES}`:
      return reducers.dataTable.replaceTableUsersInfoReducer(
        EVENT_CHANGES,
        state,
        action
      )
    default:
      return reducers.auditTable.auditTableReducer(EVENT_CHANGES)(state, action)
  }
}

export default combineReducers({
  data: eventHistoryReducer,
  tableInfo: tableReducer,
  users: (state, action) =>
    reducers.dataTable.mappedUsersReducer(EVENT_CHANGES, state, action),
})
